export default function Footer() {

    return (

        <div className='d-flex justify-content-between m-3 mt-0'>
            <small className='text-white-50'>
                MIT License
            </small>
            <a href='http://gn.dev.br/' className='small text-white-50' target='_blank' rel='noreferrer'>
                &lt;gn.dev.br/&gt;
            </a>
        </div>

    );

}